import { io } from 'socket.io-client';

// "undefined" means the URL will be computed from the `window.location` object
const URL = process.env.REACT_APP_SOCKET_URL; // process.env.NODE_ENV === 'production' ? undefined : 'http://localhost:4000';

// [28.09.2026] Токен менеджера — у рукостисканні: без нього сервер не пускає в кімнату підтримки (повідомлення клієнтів,
// нові чати, кімнати чатів, відправка через сокет). Функцією — щоб кожне (пере)підключення брало ЧИННИЙ токен.
const socket = io(URL, { auth: (cb) => cb({ token: sessionStorage.getItem('accessToken') }) });

/** Після входу — перепідключитись уже з токеном: сокет міг підключитись до входу, анонімно. */
const reconnectWithToken = () => {
    socket.disconnect();
    socket.connect();
};

socket.on('disconnect', (reason) => {
    console.log(`Socket disconnected by reason ${reason}`);
    if (reason === 'io server disconnect') {
        // the disconnection was initiated by the server, you need to reconnect manually
        socket.connect();
    }
    // else the socket will automatically try to reconnect
});

export { socket, reconnectWithToken };